import { register } from "async-ops";
import { callMvcApi } from "../../../call-web-api";
import { getDefaultOptions } from "../../../utils/fetch";
export const GET_CODER_LIST = "GET_CODER_LIST";

export const service = async () => {
  const options: object = {
    url: "/api/lookup/GetCoderList/",
    method: "POST",
    ...getDefaultOptions(),
  };
  const response = callMvcApi(options);
  return response;
};

const mockData = () => {
  return [];
};

const mock = () => {
  const promise = new Promise((resolve, reject) => {
    setTimeout(() => {
      resolve(mockData());
    }, 2000);
  });
  return promise;
};

register(GET_CODER_LIST, service, mock);
